export default function validate(field) {
  let inputErrors = [];
  if (field) {
    field.map((err) => inputErrors.push(err));
  }
  return inputErrors;
}
